module.exports = __webpack_public_path__ + "aa4bb76fa561509b29d63cd3edd8a1a9.svg";